export type PersonalGptOperation = 'post' | 'put';

const STATUS_UNPROCESSABLE_ENTITY = 422;
const STATUS_SERVICE_UNAVAILABLE = 503;

/** Maps an HTTP status of a create (post) or modify (put) call to its i18n key. */
export const getPersonalGptErrorKey = (operation: PersonalGptOperation, status: number | undefined): string => {
    const base = `error.api.${operation}.personalGpt`;
    if (status === STATUS_UNPROCESSABLE_ENTITY) {
        return `${base}.instructionRejected`;
    }
    if (status === STATUS_SERVICE_UNAVAILABLE) {
        return `${base}.moderationUnavailable`;
    }
    return base;
};

/** Reads the HTTP status from an API error, a ProblemDetails object or an axios error. */
export const getErrorStatus = (error: unknown): number | undefined => {
    if (typeof error !== 'object' || error === null) {
        return undefined;
    }
    const { status, response } = error as { status?: unknown; response?: { status?: unknown } };
    if (typeof status === 'number') {
        return status;
    }
    return typeof response?.status === 'number' ? response.status : undefined;
};

/** Returns a key only for Instruction validation outcomes (422/503); other failures keep their own message. */
export const getInstructionValidationErrorKey = (operation: PersonalGptOperation, error: unknown): string | undefined => {
    const status = getErrorStatus(error);
    return status === STATUS_UNPROCESSABLE_ENTITY || status === STATUS_SERVICE_UNAVAILABLE
        ? getPersonalGptErrorKey(operation, status)
        : undefined;
};
